import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../store/slices/session/sessionSelector";
import FirebaseAuthProvider from "../providers/FirebaseAuthProvider";

const AuthenticatedRoute: React.FC = () => {
  const user = useSelector(selectUser);
  const location = useLocation();

  return user ? (
    <FirebaseAuthProvider>
      <Outlet />
    </FirebaseAuthProvider>
  ) : (
    // Se recuerda adónde iba, para volver ahí después del login
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

export default AuthenticatedRoute;
